import { RolesActionTypes } from "./roles-types";
import { GetAllRolesNew } from "../../../services/api/role-api";

export const fetchRolesStart = () => ({
  type: RolesActionTypes.FETCH_ROLES_START,
});

export const fetchRolesFailure = () => ({
  type: RolesActionTypes.FETCH_ROLES_FAILURE,
});

export const fetchRolesSuccess = (users) => ({
  type: RolesActionTypes.FETCH_ROLES_SUCCESS,
  payload: users,
});

export const setRolesOnPage = (rolesOnPage) => ({
  type: RolesActionTypes.SET_ROLES_ON_PAGE,
  payload: rolesOnPage,
});

export const setSearchRolesQuery = (searchQuery) => ({
  type: RolesActionTypes.SET_SEARCH_ROLES_QUERY,
  payload: searchQuery,
});

export const addSelectedRole = (id) => ({
  type: RolesActionTypes.ADD_SELECTED_ROLE,
  payload: id,
});

export const deleteSelectedRole = (id) => ({
  type: RolesActionTypes.DELETE_SELECTED_ROLE,
  payload: id,
});

export const setSelectedRoles = (idList) => ({
  type: RolesActionTypes.SET_SELECTED_ROLE,
  payload: idList,
});

export const fetchRoles = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchRolesStart());

      const allRoles = await GetAllRolesNew(searchQuery);

      const roles = [];

      allRoles.Roles.forEach((role) => {
        roles.push({ role: role });
      });

      let payload = [roles, allRoles.Count];

      dispatch(fetchRolesSuccess(payload));
      dispatch(setSearchRolesQuery(searchQuery));

      dispatch(setRolesOnPage(roles));

      return allRoles;
    } catch (error) {
      dispatch(fetchRolesFailure());
      console.log(error);
    }
  };
};
